var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68889 2.88235H6.69837M6.68889 4.76471H6.69837M6.68889 10.4118H6.69837M6.68889 12.2941H6.69837M6.68889 6.64706H6.69837M6.68889 8.52941H6.69837M12.3778 5.70588H12.3873M12.3778 7.58824H12.3873M12.3778 13.2353H12.3873M12.3778 15.1176H12.3873M12.3778 9.47059H12.3873M12.3778 11.3529H12.3873M18.0667 14.1765L12.3778 17L6.68889 14.1765L1 17V3.82353L6.68889 1L12.3778 3.82353L15.2222 2.41176L18.0667 1V14.1765Z",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.75319046e1ffab6e0a4994489b230e53.svg";
export { ForwardRef as ReactComponent };